import { Helmet } from 'react-helmet-async';
import { Phone } from 'react-feather';
import FeaturesBottom from './FeaturesBottom';

function Privacy() {
  return (
    <>
      <Helmet>
        <title>Privacy Policy - Kadhr Africa</title>
        <meta name="description" content="Kadhr Africa Privacy Policy" />
      </Helmet>

      <main className="mtopcon0 ovrflwhdn" id="up">
        <a
          href="https://wa.me/254794072134"
          target="_blank"
          rel="noopener noreferrer"
          className="wappcomms btn-hover float-left"
        >
          <Phone className="text-white" />
        </a>

        <div className="row">
          <div className="col-12 pt-6indx">
            <div className="container txtul">
              <h1 className="mb-0 display-6 font-bold text-center">
                <b>
                  <span className="text-primary">Privacy</span>{' '}
                  <span className="text-dark">Policy</span>
                </b>
              </h1>
              <p className="text-center mb-4 text-grey">Updated April 2026</p>

              <h3>1. Introduction</h3>
              <p>
                Kadhr Africa is committed to protecting personal data and ensuring
                responsible use of customer information. This Privacy Policy explains
                how we collect, use, process, and safeguard data across our platform,
                APIs, integrations (including WooCommerce), and messaging systems.
              </p>

              <h3>2. Our Role</h3>
              <p>
                Kadhr Africa Limited acts as:
              </p>
              <ul>
                <li>
                  <b>Data Controller</b> for information collected directly from
                  vendors and platform users;
                </li>
                <li>
                  <b>Data Processor</b> for customer data uploaded or synced by vendors.
                </li>
              </ul>

              <h3>3. Information We Collect</h3>
              <ul>
                <li>
                  <b>Account Data:</b> name, email, phone number, login credentials,
                  subscription details;
                </li>
                <li>
                  <b>Customer Data (Processor Role):</b> names, phone numbers,
                  order history, and behavioral data uploaded via integrations,
                  APIs, or manual input;
                </li>
                <li>
                  <b>Transaction Data:</b> payments, order details, receipts;
                </li>
                <li>
                  <b>Technical Data:</b> IP address, device info, browser, logs,
                  cookies;
                </li>
                <li>
                  <b>Messaging Data:</b> message logs, delivery status,
                  engagement (opens, replies, clicks).
                </li>
              </ul>

              <h3>4. How We Use Data</h3>
              <ul>
                <li>Operate and maintain Kadhr services;</li>
                <li>Process transactions and subscriptions;</li>
                <li>Enable customer engagement and messaging workflows;</li>
                <li>Analyze behavior to improve retention and performance;</li>
                <li>Provide insights and recommendations to vendors;</li>
                <li>Ensure compliance, fraud prevention, and system security.</li>
              </ul>

              <h3>5. Messaging, Retargeting & AI Processing</h3>
              <ul>
                <li>
                  Kadhr processes customer data on behalf of vendors to enable
                  automated messaging, retention campaigns, and predictive insights;
                </li>
                <li>
                  Messages are triggered based on customer behavior such as
                  previous purchases or inactivity;
                </li>
                <li>
                  Kadhr does not independently market to vendor customers;
                </li>
                <li>
                  Vendors must ensure valid consent exists before messaging.
                </li>
              </ul>

              <h3>6. Consent & Compliance Safeguards</h3>
              <p>Kadhr implements system-level safeguards including:</p>
              <ul>
                <li>Opt-out enforcement via “STOP” and suppression lists;</li>
                <li>Message frequency limits and throttling;</li>
                <li>Monitoring for spam or abusive behavior;</li>
                <li>Ability to suspend or block non-compliant accounts;</li>
                <li>Logging of messaging activity and interactions.</li>
              </ul>

              <h3>7. Data Sharing</h3>
              <ul>
                <li>
                  <b>Service Providers:</b> SMS gateways, payment processors,
                  hosting providers;
                </li>
                <li>
                  <b>Integrations:</b> WooCommerce and other connected platforms
                  as authorized by vendors;
                </li>
                <li>
                  <b>Legal Requirements:</b> where required by law or regulators;
                </li>
                <li>
                  <b>Business Transfers:</b> in case of merger or acquisition.
                </li>
              </ul>

              <h3>8. Cross-Border Transfers</h3>
              <p>
                Data may be processed outside Kenya. Kadhr ensures appropriate
                safeguards and compliance with applicable data protection laws.
              </p>

              <h3>9. Data Retention</h3>
              <p>
                Data is retained only as long as necessary for service delivery,
                legal compliance, and dispute resolution. Vendors may delete their
                customer data at any time.
              </p>

              <h3>10. Data Security</h3>
              <p>
                Kadhr uses encryption, secure APIs, access controls, and monitoring
                systems to protect data. However, no system is completely secure.
              </p>

              <h3>11. Your Rights</h3>
              <ul>
                <li>Access your personal data;</li>
                <li>Request correction or deletion;</li>
                <li>Object to processing;</li>
                <li>Request data portability.</li>
              </ul>
              <p>
                Contact: <a href="mailto:hello@kadhr.com">hello@kadhr.com</a>
              </p>

              <h3>12. Cookies & Analytics</h3>
              <p>
                Kadhr uses cookies to improve functionality, analyze usage,
                and personalize experiences. You can manage cookies via browser settings.
              </p>

              <h3>13. Children’s Data</h3>
              <p>
                Kadhr does not knowingly process data from individuals under 18.
              </p>

              <h3>14. Updates</h3>
              <p>
                This policy may be updated periodically. Continued use implies acceptance.
              </p>

              <h3>15. Contact</h3>
              <p>
                Email: <a href="mailto:hello@kadhr.com">hello@kadhr.com</a><br />
                Website: https://kadhr.com<br />
                Data Protection Officer, Kadhr Africa
              </p>

            </div>
          </div>

          <hr />        
          <FeaturesBottom/>
        </div>
      </main>
    </>
  );
}

export default Privacy;